/* import __COLOCATED_TEMPLATE__ from './tagging-modal.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();